export const OVERVIEW = "/overview";
export const SETTINGS = "/settings";
export const DETAIL = "/detail/:id";
export const LOGIN = "/";
export const HOME = "/";
